<template>
  <section class="modal-inner">
    <div class="container">
      <!-- <div class="content-header">
                <h1>{{$t('ユーザー登録')}}</h1>
                <p>{{$t('ユーザー登録すると、お気に入りの記事を保存していつでも読み返せるようになります！')}}</p>
            </div> -->

      <div class="content-wrap">
        <div class="col-signup">
          <h2>
            <b>{{ $t("メールアドレスで登録") }}</b>
          </h2>

          <div
            class="warning"
            id="warning"
            v-if="errors.length"
            v-on:click="hideMe($event)"
          >
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>

          <form id="signin" @submit.prevent="signup">
            <input
              v-model="nickname"
              name="nickname"
              :placeholder="this.$t('Nick name')"
              id="nickname"
              autocomplete="name"
              value
              type="text"
              spellcheck="false"
            />
            <p class="caution" id="nickname-c"></p>

            <input
              v-model="email"
              v-on:blur="instantValidator($event, 'email')"
              name="email"
              :placeholder="this.$t('メールアドレス')"
              id="email"
              autocomplete="email"
              value
              type="text"
              spellcheck="false"
            />
            <p class="caution" id="email-c">{{ emailError }}</p>

            <div class="password-box">
              <input
                v-model="password"
                :type="password_type"
                v-on:blur="instantValidator($event, 'password')"
                :placeholder="this.$t('パスワード(英数字を含む6〜16文字)')"
                id="u_auth_val"
                autocomplete="new-password"
              />
              <span class="show-hide-password" v-on:click="showHidePassword"
                ><i :class="pass_type_icon"></i
              ></span>
            </div>
            <p class="caution" id="password-c">{{ passError }}</p>

            <div class="checkbox">
              <input
                type="checkbox"
                id="privacyPolicy"
                v-model="privacyPolicy"
              />
              <label
                class="check-label"
                for="privacyPolicy"
                id="privacyPolicyLabel"
              >
                <!-- <span>I have read and agree to the Terms & Conditions and Privacy Policy.</span><br> -->
                <a :href="$t('footer.privacy_policy.url')" target="_blank">
                  {{ $t("Please be sure to check our privacy policy.") }}</a
                >
              </label>
            </div>

            <div class="checkbox">
              <input type="checkbox" id="mailMagazine" v-model="mailMagazine" />
              <label class="check-label" for="mailMagazine">
                {{ $t("MATCHAメールマガジンを受け取る") }}
              </label>
            </div>
            <vue-recaptcha
              class="captcha"
              id="google_captcha"
              sitekey="6Ld4aFMUAAAAAJlKrvGeIfyIYc6WfUs4dm-Op2Zg"
              @verify="onVerifyCaptcha"
              @expired="onExpiredCaptcha"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>

            <button type="submit" class="signup-btn">
              {{ $t("ユーザー登録する") }}
            </button>
          </form>

          <div class="sns_login">
            <a
              class="facebook btn btn-gray-outline"
              v-on:click="signup_via_facebook"
              id="fb-sign-in"
            >
              <i class="icon-facebook"></i>{{ $t("Sign in with Facebook") }}
            </a>
            <a
              class="googleplus btn btn-gray-outline"
              v-on:click="signup_via_google"
              id="google-sign-in"
            >
              <span class="google-logo">{{ $t("Sign in with Google") }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as firebase from "firebase/app";
import UserUtil from "@/utils/UserUtils";
import VueRecaptcha from "vue-recaptcha";
import { googleSignInPopup } from "@/auth/google";
import { fbLoginWithPopUp } from "@/auth/facebook";
import * as emailAuth from "@/auth/email-password";
import { mapState, mapGetters, mapMutations } from "vuex";
import { redirectToInheritedPage } from "@/auth/routing";

const loader = document.getElementById("loading");

export default {
  data: () => ({
    nickname: "",
    email: null,
    password: null,
    mailMagazine: false,
    privacyPolicy: false,
    errors: [],
    emailError: "",
    passError: "",
    re_passError: "",
    captcha_token: null,
    pass_type_icon: "icon-eye-slash",
    password_type: "password",
    fbLoginCheck: false
  }),
  watch: {
    errors: function() {
      if (this.errors.length) {
        setTimeout(() => {
          this.errors = [];
        }, 7000);
      }
    }
  },
  components: { VueRecaptcha },
  computed: {
    ...mapState(["clips", "user"])
  },
  methods: {
    showHidePassword() {
      if (this.password_type === "password") {
        this.password_type = "text";
        this.pass_type_icon = "icon-eye";
      } else {
        this.password_type = "password";
        this.pass_type_icon = "icon-eye-slash";
      }
    },
    /**
     * Cognito User Pool Login System
     */
    signup() {
      if (!this.captcha_token) {
        document.getElementById("google_captcha").classList.add("captcha_skip");
        setTimeout(() => {
          document
            .getElementById("google_captcha")
            .classList.remove("captcha_skip");
        }, 1000);
        return;
      }

      if (!this.checkForm()) return;
      loader.style.display = "block";

      let additional_data = {
        language_id: UserUtil.convertToLanguageId(
          this.$store.state.languageName
        ),
        newsletter: this.mailMagazine ? 1 : 0,
        sns_registration: false,
        user_nickname: this.nickname ? this.$sanitize(this.nickname) : ""
      };

      // Firebase
      emailAuth
        .SignUp(
          this.$sanitize(this.email),
          this.$sanitize(this.password),
          additional_data
        )
        .then(result => {
          // console.log(result)
          // loader.style.display = "none";
          this.$swal({
            title: this.$root.$t("ユーザー登録"),
            text: this.$root.$t(
              "Your account has been registered. Please, verify your email address for completing the registration process."
            ),
            type: "success"
          }).then(res => {
            // this.$router.push('/');
            redirectToInheritedPage();
          });
        })
        .catch(error => {
          // console.log(error)

          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode === "auth/email-already-in-use") {
            firebase
              .auth()
              .fetchSignInMethodsForEmail(this.$sanitize(this.email))
              .then(methods => {
                loader.style.display = "none";
                if (methods[0] === "facebook.com") {
                  this.errors.push(
                    this.$root.$t(
                      "You’ve already used this email for facebook sign in. Sign in with Facebook to continue."
                    )
                  );
                } else if (methods[0] === "google.com") {
                  this.errors.push(
                    this.$root.$t(
                      "You’ve already used this email for google sign in. Sign in with Google to continue."
                    )
                  );
                } else {
                  this.errors.push(this.$root.$t(errorMessage));
                }
              });
          } else {
            loader.style.display = "none";
            this.errors.push(this.$root.$t(errorMessage));
            // this.toastMessage('top', 'error', this.$t('Error'), this.$t(errorMessage));
          }
        });
    },
    signup_via_facebook() {
      loader.style.display = "block";
      let additional_data = {
        language_id: UserUtil.convertToLanguageId(
          this.$store.state.languageName
        )
      };

      fbLoginWithPopUp(additional_data)
        .then(result => {
          // console.log(result.user)
          // loader.style.display = "none";

          this.$swal({
            title: this.$root.$t("ユーザー登録"),
            text: this.$root.$t("Your account has been registered."),
            type: "success"
          }).then(res => {
            // this.$router.push('/');
            redirectToInheritedPage();
          });
        })
        .catch(error => {
          // console.log(error)
          if (error.code === "auth/account-exists-with-different-credential") {
            this.existingAccountMergeForSNS(error)
              .then(res => {
                // console.log(res)
                // loader.style.display = "none";
                // this.$router.push('/')
                redirectToInheritedPage();
              })
              .catch(err => {
                loader.style.display = "none";
              });
          } else {
            var errorCode = error.code;
            var errorMessage = error.message;
            loader.style.display = "none";

            this.errors.push(this.$root.$t(errorMessage));
          }
        });
    },

    signup_via_google() {
      loader.style.display = "block";
      let additional_data = {
        language_id: UserUtil.convertToLanguageId(
          this.$store.state.languageName
        )
      };

      googleSignInPopup(additional_data)
        .then(result => {
          // console.log(result.user)
          // loader.style.display = "none";

          this.$swal({
            title: this.$root.$t("ユーザー登録"),
            text: this.$root.$t("Your account has been registered."),
            type: "success"
          }).then(res => {
            // this.$router.push('/');
            redirectToInheritedPage();
          });
        })
        .catch(error => {
          // console.log(error)
          if (error.code === "auth/account-exists-with-different-credential") {
            this.existingAccountMergeForSNS(error)
              .then(res => {
                // console.log(res)
                // loader.style.display = "none";
                // this.$router.push('/')
                redirectToInheritedPage();
              })
              .catch(err => {
                loader.style.display = "none";
              });
          } else {
            var errorCode = error.code;
            var errorMessage = error.message;
            loader.style.display = "none";

            this.errors.push(this.$root.$t(errorMessage));
          }
        });
    },

    existingAccountMergeForSNS(error) {
      return new Promise((resolve, reject) => {
        if (error.code === "auth/account-exists-with-different-credential") {
          var pendingCred = error.credential;
          var email = error.email;
          var auth = firebase.auth();

          // Get sign-in methods for this email.
          auth.fetchSignInMethodsForEmail(email).then(methods => {
            // console.log(methods)
            if (methods[0] === "password") {
              // Alert: You have existing account with the same email via password credentials.
              // Alert: Please input existing account password to continue.
              this.$swal({
                title: this.$root.$t("Account already exist!"),
                text: this.$root.$t(
                  "You have existing account with the same email via password credentials. Please input existing account password to continue with merge this account to existing account."
                ),
                input: "password",
                showCancelButton: true,
                confirmButtonText: this.$root.$t("Login & Merge"),
                // showLoaderOnConfirm: true,
                allowOutsideClick: false
              }).then(result => {
                // console.log(result.value)
                if (result.value) {
                  var password = this.$sanitize(result.value);

                  auth
                    .signInWithEmailAndPassword(email, password)
                    .then(user => {
                      auth.currentUser
                        .linkWithCredential(pendingCred)
                        .then(res => {
                          this.$swal({
                            title: this.$root.$t("ユーザー登録"),
                            text: this.$root.$t(
                              "Your account successfully linked to the existing user."
                            ),
                            type: "success"
                          });
                          // console.log(res);
                          resolve(res);
                        });
                    })
                    .catch(err => {
                      var errorCode = err.code;
                      var errorMessage = err.message;

                      this.$swal({
                        title: this.$root.$t("ユーザー登録"),
                        text: this.$root.$t(errorMessage),
                        type: "error"
                      });
                      reject(err);
                    });
                }
              });
            } else {
              var provider =
                methods[0] === "google.com"
                  ? new firebase.auth.GoogleAuthProvider()
                  : new firebase.auth.FacebookAuthProvider();
              var message =
                methods[0] === "facebook.com"
                  ? this.$root.$t(
                      "You’ve already used this email for facebook sign in. Sign in with Facebook to continue."
                    )
                  : this.$root.$t(
                      "You’ve already used this email for google sign in. Sign in with Google to continue."
                    );

              this.$swal({
                title: this.$root.$t("Account already exist!"),
                text: message,
                showCancelButton: true,
                confirmButtonText: this.$root.$t("Login & Merge"),
                // showLoaderOnConfirm: true,
                allowOutsideClick: false
              }).then(result => {
                if (result.value) {
                  auth
                    .signInWithPopup(provider)
                    .then(res => {
                      auth.currentUser
                        .linkAndRetrieveDataWithCredential(pendingCred)
                        .then(usercred => {
                          this.$swal({
                            title: this.$root.$t("ユーザー登録"),
                            text: this.$root.$t(
                              "Your account successfully linked to the existing user."
                            ),
                            type: "success"
                          });
                          // console.log(usercred);
                          resolve(usercred);
                        });
                    })
                    .catch(err => {
                      var errorCode = err.code;
                      var errorMessage = err.message;

                      this.$swal({
                        title: this.$root.$t("ユーザー登録"),
                        text: this.$root.$t(errorMessage),
                        type: "error"
                      });
                      reject(err);
                    });
                }
              });
            }
          });
        }
      });
    },

    instantValidator(el, type) {
      if (type === undefined) return;
      if (type === "email") {
        if (!this.email) {
          this.emailError = this.$t("Email field is empty.");
        } else if (!this.emailValidator(this.email)) {
          this.emailError = this.$t("Invalid email adrress.");
        } else {
          this.emailError = "";
        }
      } else if (type === "password") {
        if (!this.password) {
          this.passError = this.$t("Password field is empty.");
        } else if (!this.passwordValidator(this.password)) {
          if (this.password.length < 6) {
            this.passError = this.$t(
              "Please set a password with more than 6 characters."
            );
          } else if (this.password.length > 16) {
            this.passError = this.$t(
              "Please set a password with less than 16 characters."
            );
          } else if (
            !/^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9])+$/.test(this.password)
          ) {
            this.passError = this.$t(
              "Password should contain both alphabets and numbers."
            );
          } else {
            this.passError = this.$t("Invalid password format.");
          }
        } else {
          this.passError = "";
        }
      }
    },

    checkForm: function(e) {
      this.errors = [];
      if (!this.email) {
        this.errors.push(this.$t("Please input a valid email address."));
      } else if (!this.validEmail(this.email)) {
        this.errors.push(this.$t("Invalid email adrress."));
      }

      if (!this.password) {
        this.errors.push(this.$t("Please input a valid password."));
      } else if (!this.passwordValidator) {
        this.errors.push(this.$t("Invalid password format."));
      }

      if (!this.privacyPolicy) {
        this.errors.push(
          this.$t("Please be sure to check our privacy policy.")
        );
      }
      if (!this.errors.length) return true;
    },

    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    emailValidator: function(email) {
      if (!email) return false;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    passwordValidator: function(pass) {
      if (!pass) return false;
      var re = /^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9]).{5,16}$/; //previous one : /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      return re.test(pass);
    },

    toastMessage(position, type, title, text) {
      this.$swal({
        toast: true,
        position: position,
        showConfirmButton: false,
        padding: "2rem",
        timer: 6000,
        type,
        title,
        text
      });
    },

    onVerifyCaptcha(e) {
      if (e) this.captcha_token = e;
    },
    onExpiredCaptcha() {
      this.captcha_token = null;
    },

    hideMe(e) {
      e.preventDefault();
      this.errors = [];
      this.errors.length = 0;
      var element = e.target;
      element.style.display = "none";
      // sconsole.log(e)
    },

    getNestedObject: function(nestedObj, pathArr) {
      return pathArr.reduce(
        (obj, key) => (obj && obj[key] !== "undefined" ? obj[key] : undefined),
        nestedObj
      );
    }
  },

  //For Header & Meta Tag
  metaInfo() {
    return {
      title: this.$t("ユーザー登録") + " | MATCHA - JAPAN TRAVEL WEB MAGAZINE"
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/users/register.vue